module.exports = __webpack_public_path__ + "img/tn-timeline-main-17.7b306c59.jpg";